export default __webpack_public_path__ + "static/media/11.24f6c9de.jpg";